import React from 'react';
import { ButtonType } from './ButtonStyledComponent';


interface Props {
  children: JSX.Element | JSX.Element[];
  page?: string;
  color?: string;
  backgroundColor?: string;
  border?: string;
  borderColor?: string;
  fontWeight?: number;
  click: (data?: any) => void;
  disabled?: boolean;
  id?: string;
  gap?: string;
  minWidth?: string;
}

const Button = ({
  children,
  page,
  color,
  backgroundColor,
  border,
  borderColor,
  fontWeight,
  click,
  disabled,
  id,
  gap,
  minWidth
}: Props) => {

  return (
    <ButtonType
      type="button"
      color={color}
      backgroundColor={backgroundColor}
      border={border}
      borderColor={borderColor}
      fontWeight={fontWeight}
      disabled={disabled}
      opacityOnDisabled={disabled}
      id={id}
      gap={gap}
      minWidth={minWidth}
      onClick={() => click()}
    >
      {children}
    </ButtonType>
  );
};

export default Button;
